/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PearsonCourseTemplatePermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['view', codecBoolean],
    ['edit', codecBoolean],
]);
export class PearsonCourseTemplatePermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PearsonCourseTemplatePermissionsParser.decode(input).map(res => new PearsonCourseTemplatePermissions(res));
    }
    static unsafeDecode(input) {
        return PearsonCourseTemplatePermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PearsonCourseTemplatePermissionsParser.encode(data);
    }
    static schema() {
        return PearsonCourseTemplatePermissionsParser.schema();
    }
}
